import { render, staticRenderFns } from "./LimitAlertFormComponent.vue?vue&type=template&id=1d3acac7&"
import script from "./LimitAlertFormComponent.vue?vue&type=script&lang=js&"
export * from "./LimitAlertFormComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports